import { render } from "./ResidentOffice.vue?vue&type=template&id=337f0a38&scoped=true"
import script from "./ResidentOffice.vue?vue&type=script&lang=js"
export * from "./ResidentOffice.vue?vue&type=script&lang=js"

import "./ResidentOffice.vue?vue&type=style&index=0&id=337f0a38&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337f0a38"]])

export default __exports__